var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientCaricature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 326.723,
    height: 297.119,
    viewBox: "0 0 326.723 297.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dadada;}.b{fill:none;}.c{clip-path:url(#a);}.d{fill:#c3cad1;}.e{fill:#dd846f;}.f{fill:#d3dae2;}.g{fill:#e4ebf2;}.h{fill:#ffe49f;}.i{opacity:0.2;}.j{clip-path:url(#b);}.k{fill:#fff;}.l{clip-path:url(#c);}.m{fill:#07938c;}.n{fill:#07b1ae;}.o{opacity:0.1;}.p{clip-path:url(#d);}.q{fill:#777e7f;}.r{opacity:0.41;}.s{clip-path:url(#e);}.t{clip-path:url(#f);}.u{fill:#aab6bc;}.v{fill:#bdccd4;}.w{fill:#c6b28d;}.x{fill:#fba386;}.y{fill:#dd8775;}.z{fill:#5e3d34;}.aa{clip-path:url(#g);}.ab{clip-path:url(#h);}.ac{fill:#e5d3ac;}.ad{opacity:0.23;}.ae{clip-path:url(#i);}.af{clip-path:url(#j);}.ag{fill:#ef9178;}.ah{opacity:0.05;}.ai{clip-path:url(#k);}.aj{clip-path:url(#l);}.ak{clip-path:url(#m);}.al{fill:#fc2d50;}.am{opacity:0.11;}.an{clip-path:url(#n);}.ao{clip-path:url(#o);}.ap{fill:#252828;}.aq{fill:#343838;}.ar{fill:#ed9077;}.as{fill:#99a5aa;}.at{opacity:0.13;}.au{clip-path:url(#p);}.av{opacity:0.07;}.aw{clip-path:url(#q);}.ax{fill:#dfe8ef;}.ay{opacity:0.09;}.az{clip-path:url(#r);}.ba{opacity:0.49;}.bb{clip-path:url(#s);}.bc{fill:#dfe6ef;}.bd{clip-path:url(#t);}.be{fill:#09141e;}.bf{fill:#d0d6e2;}.bg{fill:#bdc1c6;}.bh{opacity:0.61;}.bi{clip-path:url(#u);}.bj{clip-path:url(#v);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 326.361,
    height: 37.731,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 21.948,
    height: 21.151
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 17.025,
    height: 16.388
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30.052,
    height: 46.527
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 178.477,
    height: 69.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 55.876,
    height: 54.074
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.559,
    height: 5.723
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 4.558,
    height: 5.723
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 12.509,
    height: 8.847
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 14.655,
    height: 8.204
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 19.916,
    height: 34.686
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 7.053,
    height: 3.453
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10.631,
    height: 9.921
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 74.394,
    height: 39.881
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 51.837,
    height: 45.028
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 122.997,
    height: 33.022
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3.481,
    height: 2.168
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 37.644,
    height: 13.729
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 52.936,
    height: 11.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 65.011,
    height: 37.909
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 47.303,
    height: 4.144
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12.11,
    height: 12.11,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-791.638 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(792 639.388)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.1,0H319.074A7.141,7.141,0,0,1,326.36,7c0,.04,0,.08,0,.12a6.326,6.326,0,0,1-6.35,6.3l-.121,0H274.546a6.107,6.107,0,0,0-6.239,5.964,5.951,5.951,0,0,0,6.122,5.775l.117-.005h7.134a7.107,7.107,0,0,1,5.765,3.011,5.146,5.146,0,0,1,1.1,3.962,6.564,6.564,0,0,1-6.731,5.6H53.653a6.484,6.484,0,0,1-6.7-5.537,5.8,5.8,0,0,1,1.062-4.155,7.094,7.094,0,0,1,5.844-2.881H66.914A5.95,5.95,0,0,0,73.15,19.5c0-.056,0-.113.006-.169a6.027,6.027,0,0,0-6.133-5.919l-.109,0H7.117c-4.152,0-7.5-3.166-7.082-7.427A6.875,6.875,0,0,1,7.1,0"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M172.846,40.833a4.86,4.86,0,0,1,4.846,4.846v17.3a4.846,4.846,0,0,1-9.691,0l.455-19.332s1.726-2.81,4.391-2.81",
    transform: "translate(804.634 372.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M197.926,212c2.443.367,3.742,3.649,3.742,3.649l-10.587,0a6.035,6.035,0,0,1,.371-2.336c.444-1.051,4.031-1.675,6.474-1.308",
    transform: "translate(762.021 339.228)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M191.92,216.37l1.261,1.308a26,26,0,0,0-2.424,1.95c-.992.939-.255-2.082,1.162-3.257",
    transform: "translate(771.134 338.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M181.122,69.667l14.49-4.16a2.423,2.423,0,0,1,1.337,4.657l-14.489,4.16a6.73,6.73,0,0,0-4.612,8.326l2.378,8.279a2.423,2.423,0,0,1-4.658,1.337l-2.377-8.28a11.575,11.575,0,0,1,7.932-14.32",
    transform: "translate(779.796 367.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M161.742,87.611l.065-.019a2.154,2.154,0,0,1,2.664,1.475l1.859,6.475a3.794,3.794,0,0,0,4.647,2.6l28.531-7.972.027-.007a3.758,3.758,0,0,0,2.588-2.622,3.866,3.866,0,0,0-.051-2.121l-1.857-6.47a2.288,2.288,0,0,1,1.568-2.831,2.557,2.557,0,0,1,3.163,1.752l1.757,6.122a8.794,8.794,0,0,1-.023,5.219,8.59,8.59,0,0,1-5.808,5.605l-.061.018-28.532,7.972a8.66,8.66,0,0,1-10.608-5.925l-1.729-6.021a2.625,2.625,0,0,1,1.8-3.247",
    transform: "translate(781.825 365.373)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M172.881,78.73,186.6,74.793a6.884,6.884,0,0,1,8.492,4.7l3.491,12.161a6.884,6.884,0,0,1-4.7,8.492l-13.714,3.937a6.885,6.885,0,0,1-8.492-4.7l-3.491-12.161a6.884,6.884,0,0,1,4.7-8.492",
    transform: "translate(783.553 365.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M178.008,80.2l13.714-3.937a6.884,6.884,0,0,1,8.492,4.7L203.7,93.13a6.885,6.885,0,0,1-4.7,8.492l-13.714,3.937a6.885,6.885,0,0,1-8.492-4.7L173.3,88.693a6.885,6.885,0,0,1,4.7-8.492",
    transform: "translate(774.286 365.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M178.861,81.75,192.27,77.9a5.64,5.64,0,0,1,6.957,3.853l3.448,12.012a5.639,5.639,0,0,1-3.853,6.957l-13.409,3.85a5.641,5.641,0,0,1-6.957-3.853l-3.448-12.013a5.639,5.639,0,0,1,3.853-6.956",
    transform: "translate(773.949 365.053)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(951.816 445.712)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M182.67,84.046l8.565-2.459a5.639,5.639,0,0,1,6.957,3.853l2.139,7.448a5.641,5.641,0,0,1-3.854,6.957l-8.565,2.459a5.639,5.639,0,0,1-6.956-3.853L178.818,91a5.639,5.639,0,0,1,3.852-6.956",
    transform: "translate(-178.6 -81.369)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(954.278 448.095)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M185.719,85.883l4.69-1.347a5.641,5.641,0,0,1,6.957,3.853l1.089,3.8a5.639,5.639,0,0,1-3.853,6.956l-4.69,1.347a5.639,5.639,0,0,1-6.956-3.854l-1.09-3.8a5.639,5.639,0,0,1,3.853-6.956",
    transform: "translate(-181.648 -84.319)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M189.99,88.536a4.543,4.543,0,1,1-3.112,5.62,4.543,4.543,0,0,1,3.112-5.62",
    transform: "translate(771.435 362.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M301.023,114.522c4.894-1.824,15.174-2.574,15.174-2.574s10.107,11.444,12.656,18.283c4.712,12.647,9.2,25.974-10.763,30.09-19.614,4.042-23.116-3.062-27.829-15.709s.106-26.119,10.763-30.09",
    transform: "translate(552.168 358.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M287.023,112.871c10.657-3.971,23.116,3.062,27.829,15.709s9.2,25.974-10.763,30.09c-19.614,4.042-23.116-3.062-27.829-15.709s.106-26.119,10.763-30.09",
    transform: "translate(577.475 358.495)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(866.66 470.278)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.322,114.2a17.4,17.4,0,0,1,1.472-2.411c8.657.363,17.173,6.837,20.885,16.8,3.4,9.135,7.23,23.612,1.27,29.73-4.541-.164-12.6-2.558-17-4.48-12.585-5.5-9.917-25.137-9.225-30.11a32.471,32.471,0,0,1,2.6-9.526",
    transform: "translate(-274.012 -111.788)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 128.435,
    height: 12.642,
    transform: "translate(871.79 568.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M199.3,242.722l25.439,44.44L294.8,301.9v10.136l-77.6.362L101.333,272.045l15.293-27.483Z",
    transform: "translate(741.364 333.297)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "r",
    transform: "translate(857.688 576.019)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.752,287.162,279.81,301.9v10.136l-76.181.355-22.974-49.564a12,12,0,0,0-10.575-7.22l-68.746-2.486v-8.56l82.829-1.84Z",
    transform: "translate(-101.333 -242.722)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M138.472,166.75h40.309a3.729,3.729,0,0,1,3.374,2.14L205.5,218.426a3.73,3.73,0,0,0,3.374,2.14h11.677c9.043,0,14.633.3,20.3,11.82a3.79,3.79,0,0,0,1.123,1.367l66.312,49.629a3.73,3.73,0,0,1-2.235,6.716h-40.9a18.733,18.733,0,0,1-16.939-10.732l-17.627-37.322a15.422,15.422,0,0,0-13.945-8.836H146.9c-6.857-.191-10.114-6.991-12.451-12.642l-12.833-27.254a18.627,18.627,0,0,1,16.853-26.561",
    transform: "translate(711.441 347.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M257,166.688,298,166.429l23.23,54.075H266.022a13.822,13.822,0,0,1-12.505-7.935L242.6,189.377A15.911,15.911,0,0,1,257,166.688",
    transform: "translate(602.088 347.977)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(867.442 514.406)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.8,166.593l25.911-.164L296.942,220.5H260.726c-8.273-14.834-17.177-30.037-19.585-46.115a6.783,6.783,0,0,1,6.658-7.8",
    transform: "translate(-241.065 -166.43)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M164.891,242.987l24.64,52.346a5.32,5.32,0,0,1-4.814,7.586H136.576a11.745,11.745,0,0,1-10.626-6.742L95.857,233.388h53.906a16.719,16.719,0,0,1,15.128,9.6",
    transform: "translate(850.543 335.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M92.371,325.891H231.165a2.518,2.518,0,0,1,2.51,2.51v.535a2.517,2.517,0,0,1-2.51,2.51H92.371a2.517,2.517,0,0,1-2.509-2.51V328.4a2.518,2.518,0,0,1,2.509-2.51",
    transform: "translate(811.754 317.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M266.615,148.583c11.023,3.474,8.164,11.072,6.542,14.021a.75.75,0,0,1-1.335-.05l-6.078-12.989a.716.716,0,0,1,.871-.982",
    transform: "translate(628.709 351.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M267.653,100.057s3.646-3.19,7.168-1.445c5.1,2.524,26.442,15.225,18.407,38.678-8.464,24.706-26.006,16.364-26.006,16.364s-22.063-1.015-19.536-25.449,15.722-30.488,19.966-28.148",
    transform: "translate(623.117 361.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M272.805,149.042a4.044,4.044,0,0,1,4.338,3.683l1.341,9.769a3.82,3.82,0,1,1-7.521,1.043l-1.341-9.769a4.058,4.058,0,0,1,3.184-4.726",
    transform: "translate(621.766 351.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M273.952,149.042a4.044,4.044,0,0,1,4.337,3.683l.459,3.346a15.494,15.494,0,0,1-7.578.628l-.4-2.93a4.058,4.058,0,0,1,3.184-4.726",
    transform: "translate(620.619 351.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M271.86,102.268a18.166,18.166,0,0,1,5.874.933,20.033,20.033,0,0,1,10.024,7.9,21.592,21.592,0,0,1,1.844,3.274l.07.157c4.5,10.072,1.944,25.411-8.891,30.42a16.137,16.137,0,0,1-7.467,1.538c-10.156-.4-18.75-10.639-19.3-20.905-.565-10.582,5.976-23.272,17.844-23.321",
    transform: "translate(621.103 360.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M300.763,131.115c.023.436-.052-.435,0,0",
    transform: "translate(574.356 354.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M271.863,102.268a18.167,18.167,0,0,1,5.874.933,20.033,20.033,0,0,1,10.024,7.9,21.59,21.59,0,0,1,1.844,3.274l.07.157a27.066,27.066,0,0,1,.186,20.506,11.627,11.627,0,0,0-2.3-6.637c-7.226-7.035-15.141-7.573-18.582-15.834-2.847,6.884-12.334,11.814-14.961,13.018-.565-10.582,5.976-23.272,17.844-23.321",
    transform: "translate(621.1 360.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M266.486,140.676l14.182.312a1.172,1.172,0,0,1,1.042,1.652c-1.614,3.54-4.758,5.927-8.3,5.849s-6.579-2.6-8.036-6.208a1.171,1.171,0,0,1,1.113-1.606",
    transform: "translate(621.942 352.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M262.464,130.138c1.358-.039,2.5,1.353,2.55,3.108s-1.01,3.21-2.368,3.249-2.5-1.353-2.55-3.108,1.01-3.21,2.368-3.249",
    transform: "translate(642.935 354.96)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(903.357 485.729)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M264.7,133.394c.051,1.756-1.009,3.21-2.367,3.249a2.446,2.446,0,0,1-2.189-1.587c1.16-1.395,2.325-2.782,3.528-4.136a3.546,3.546,0,0,1,1.028,2.474",
    transform: "translate(-260.139 -130.92)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M285.9,130.134c1.358-.039,2.5,1.353,2.55,3.108s-1.01,3.209-2.368,3.248-2.5-1.353-2.55-3.108,1.01-3.21,2.368-3.249",
    transform: "translate(600.578 354.961)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(884.434 485.729)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M288.127,133.394c.05,1.756-1.01,3.21-2.368,3.249a2.444,2.444,0,0,1-2.189-1.587c1.159-1.395,2.324-2.782,3.528-4.136a3.55,3.55,0,0,1,1.029,2.474",
    transform: "translate(-283.571 -130.92)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M265.572,100.057s3.645-3.19,7.168-1.446c5.1,2.525,28.228,15.784,20.194,39.237-2.556,7.46-7.725,11.344-11.2,13.918,4.686-4.988,6.289-12.94,5.173-19.082-2.063-13.766-20.679-11.229-21.479-27.318,0,11.012-12.245,13.166-17.753,21.424-1.341,2.01-1.6,5.22-2.18,7.41a34.033,34.033,0,0,1,.115-6c2.528-24.434,15.721-30.487,19.966-28.147M281.4,120.983c-2.752-4.13-8.488-6.2-10.552-11.015,0,5.506,7.111,7.573,10.552,11.015",
    transform: "translate(625.198 361.126)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ad",
    transform: "translate(874.68 469.135)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M288.442,110.558a23.757,23.757,0,0,0,9.872,5.542,27.015,27.015,0,0,1-3.422,3.12,19.3,19.3,0,0,1-5.19-1.882,24.945,24.945,0,0,1-3.9-2.7,33.344,33.344,0,0,1,2.242-4.262c.131.065.264.123.4.186",
    transform: "translate(-285.805 -110.372)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ad",
    transform: "translate(899.077 469.506)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "af"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M261.712,113.256a16.77,16.77,0,0,0,3.574-2.424c.8.854,1.57,1.76,2.306,2.716a29.787,29.787,0,0,1-11.266,5.488c-1.148-.92-2.325-1.825-3.39-2.821,1.046-.231,2.079-.5,3.086-.813a42.172,42.172,0,0,0,5.69-2.147",
    transform: "translate(-252.936 -110.832)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M205.912,163.068l3.035-2.466a11.732,11.732,0,0,1,6.99,6.189c5.855,11.922,14.511,25.96,19.819,28.3,8.269,3.651,10.1,3.556,15.683,4.291L252.4,207c-.031,0-.132,0-.3,0-1.592,0-9.714-1.686-19.918-5.886-11.029-4.539-23.513-30.452-26.729-37.592a.343.343,0,0,1,.453-.453",
    transform: "translate(699.696 349.098)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ah",
    transform: "translate(905.124 509.7)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.417,163.068l3.035-2.466a11.732,11.732,0,0,1,6.99,6.189,161.623,161.623,0,0,0,9.407,16.662A22.424,22.424,0,0,0,257.8,191.3a24.586,24.586,0,0,0,.383,3.983c-8.648-9.389-16.725-26.226-19.221-31.766a.343.343,0,0,1,.453-.453",
    transform: "translate(-238.933 -160.602)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ad",
    transform: "translate(894.248 475.137)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M275.382,120.662a35.973,35.973,0,0,1-3.662.6,20.624,20.624,0,0,1-3.391-3.02,29.365,29.365,0,0,0,3.569-.433,18.289,18.289,0,0,0,3.485,2.858",
    transform: "translate(-268.329 -117.804)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ad",
    transform: "translate(908.267 480.329)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M256.519,124.233q.365,1,.652,2.052a33.668,33.668,0,0,1-7.711,7.87,13.254,13.254,0,0,0-2.919-4.246c.127-.056.255-.107.381-.163a68.386,68.386,0,0,0,9.6-5.513",
    transform: "translate(-246.54 -124.233)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M298.353,129.7c1.82-.6,3.985,1,4.837,3.573s.066,5.149-1.754,5.751-3.985-1-4.837-3.572-.066-5.15,1.754-5.752",
    transform: "translate(575.214 355.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M257.721,161.467c1.8-.254,9.421-1.033,9.421-1.033,1.171,1.459,3.46,2.512,5.434,3.661a3.161,3.161,0,0,0,.056,1.028c1.221,5.366,5.041,9.137,9.047,12.622a19.751,19.751,0,0,1-.122,3.209c-8.956,1.908-17.918,3.807-26.85,5.824-3.445-7.248-4.355-14.75-8.653-21.5,1.983-.939,1.786-1.669,3.881-2.323a47.847,47.847,0,0,1,7.787-1.486",
    transform: "translate(637.594 349.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M234.239,163.8a15.579,15.579,0,0,1,3.493-1.136c1.079,3.9,12.995,6.713,12.995,6.713s4.239-4.081,3.381-8.969c.782-.031,1.572-.057,2.363-.088a4.76,4.76,0,0,1,4.741,3.761c1.264,7.414,6.673,8.821,7.209,11.7a19.456,19.456,0,0,1-.165,6.994c-.3,1.653-.122,1.651.407,5.305.124.862,2.828,6.176,13.059,17.938-8.475,3.842-30.753,6.526-39.842.931-2.607-21.485-7.347-26.071-11.234-33.623a6.86,6.86,0,0,1,3.594-9.523",
    transform: "translate(650.629 349.152)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(949.032 568.975)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.227,234c6.658,6.461,12.872,15.731,17.135,22.416,2.811,2.457,3.63,2.932,4.758,4.159a27.632,27.632,0,0,0,2.191,2.066c1.925,1.049,4.37,2.273,6.751,3.277,5.05,2.128,6.858,3.969,6.359,5.833s-6.565,3.682-14.8-.019c-.43-.193-.826-.368-1.214-.535a2.291,2.291,0,0,1-.073.54c-.5,1.864-6.565,3.689-14.8-.011s-8.24-1.527-9.592-4.208a7.7,7.7,0,0,1,.174-5.857c-.394-.358-.952-.812-1.761-1.429-15.705-11.35-24.461-24.114-32.249-25.643l4.636-.591Z",
    transform: "translate(-117.107 -234)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(880.513 514.272)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.134,166.264a5.224,5.224,0,0,0,.56,1.3c4.082,6.722,7.88,11.77,16.073,13.2,6.164,1.076,14,1.443,19.9-1.076a23.651,23.651,0,0,1-.409,4.232c-.3,1.653-.122,1.651.407,5.305.124.861,2.828,6.175,13.059,17.938-8.476,3.842-30.753,6.526-39.842.93-2.607-21.485-7.347-26.07-11.234-33.622a6.849,6.849,0,0,1,1.491-8.207",
    transform: "translate(-229.882 -166.264)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M119.683,259.093c2.327.367,5.635,1.187,5.635,1.187a92.6,92.6,0,0,0,9.235,7.23c4.57,3.024,6,5.183,5.169,6.923s-7.133,2.413-14.542-2.745-7.945-3.736-8.651-5.906.828-7.056,3.155-6.688",
    transform: "translate(884.087 330.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M129.617,252.734c3.259,4.206,4.022,4.937,5.035,6.562a27.313,27.313,0,0,0,6.966,7.563c1.063.779-.97,2.821-2.1,3.041a5.006,5.006,0,0,1-3.1-.682c-2.131-1-7.972-4.12-9.542-7.8-.7-1.646,1.074-2.054-3.2-5.592l1.441-3.028Z",
    transform: "translate(876.202 331.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M133.856,261.107c2.356-.069,5.757.126,5.757.126a92.528,92.528,0,0,0,10.411,5.4c5.05,2.128,6.857,3.985,6.358,5.849s-6.565,3.69-14.8-.01-8.241-1.526-9.593-4.207c-1.028-2.037-.491-7.087,1.865-7.156",
    transform: "translate(855.345 329.762)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M144.723,254.387c3.979,3.532,4.865,4.109,6.161,5.519a27.3,27.3,0,0,0,8.244,6.147c1.188.569-.433,2.951-1.5,3.376a5,5,0,0,1-3.174-.1c-2.279-.586-8.6-2.576-10.818-5.9-.993-1.488-.324-1.407-3.823-4.037l.5-4.11Z",
    transform: "translate(845.543 331.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M189.89,216.831c11.3.487,24.832,20.008,32.257,31.65-5.16.016-5.859,2.23-5.951,2.409-14.861-11.7-21.254-20.244-23.774-20.573-16.367-2.138-55.673-.9-56.151-.894l.919-12.459c1.959-.013,36.012-.851,52.7-.132",
    transform: "translate(785.804 338.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M187.928,212.969c1.19,1.914,4.841,7.234,4.258,7.547s-7.493-7.471-7.493-7.471l-.893-1.475s2.939-.514,4.128,1.4",
    transform: "translate(777.318 339.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M201.858,211.834c2.164,2.184,6.212,7.662,5.043,7.812s-7.23-7.226-7.23-7.226-3.716-.44-5.24.582c-2.187,1.468,2.527,4.056,2.088,6.288-.316,1.607-2-1.32-3.042-2.157s-7.3-3.15-7.3-3.15l3.738-5.463s9.782,1.131,11.947,3.315",
    transform: "translate(760.54 339.878)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M188.728,212.856c.5.953.045,3.758.045,3.758l-2.187-3.874s1.639-.837,2.142.116",
    transform: "translate(778.352 339.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M217.013,216.208c16.468,1.809,30.55,19.931,38.481,32.158-4.968-1.655-6.29,2.428-6.363,3.673-17.1-12.349-21.234-20.9-25.918-21-11.571-.246-37.4-.632-55.173-.743a12.28,12.28,0,0,1-12.186-12.923c1.958-.013,20.778-5.6,61.16-1.166",
    transform: "translate(736.655 338.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M194.9,273.5a6.427,6.427,0,0,1,4.749-.258L315.74,309.894c3.179,1,2.55,5.764-.784,5.8h-.1l-117.035,2.508c-3.222,0-5.513-4.413-5.513-6.74V277A4.1,4.1,0,0,1,194.9,273.5",
    transform: "translate(644.872 327.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M199.933,325.891H321.622a2.518,2.518,0,0,1,2.51,2.51v.535a2.517,2.517,0,0,1-2.51,2.51H199.933a2.517,2.517,0,0,1-2.51-2.51V328.4a2.518,2.518,0,0,1,2.51-2.51",
    transform: "translate(634.431 317.294)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "at",
    transform: "translate(838.439 609.28)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "au"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M196.751,283.973l118.318,28.343a2.339,2.339,0,0,1-1.09,4.55L195.661,288.523a2.34,2.34,0,0,1,1.09-4.551",
    transform: "translate(-193.866 -283.908)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "av",
    transform: "translate(892.507 457.107)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M278.389,97.426c-1.089.027-2.182.1-3.276.22a6.09,6.09,0,0,1-.176-2.168,8.648,8.648,0,0,1,3.452,1.947",
    transform: "translate(-274.907 -95.479)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M227.9,168.479a4.583,4.583,0,0,1,5.228,3.2c2,6.737,7.25,20.089,18.383,24.489,15.644,6.183,22.193,5.662,27.947,5.662l1.621,6.135c-.305.1-4.375,0-10.974,0a58.637,58.637,0,0,1-21.563-4.287c-15.033-5.941-21.332-23.011-23.461-30.707a3.594,3.594,0,0,1,2.818-4.493",
    transform: "translate(655.252 347.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M181.27,166.653h61.377A5.659,5.659,0,0,0,248.3,161l7.908.269a13.374,13.374,0,0,1-13.561,13.46H181.27a5.66,5.66,0,0,0-5.653,5.653v8.076h-8.076v-8.076a13.744,13.744,0,0,1,13.729-13.729",
    transform: "translate(726.489 349.021)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ay",
    transform: "translate(945.051 510.021)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.144,166.653h22.481A5.659,5.659,0,0,0,197.278,161l7.908.269a13.374,13.374,0,0,1-13.561,13.46H177.114c-7.9,0-12.073-8.076-7.97-8.076",
    transform: "translate(-167.541 -161)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ba",
    transform: "translate(836.367 527.998)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M286.327,183.26H332.98a3.138,3.138,0,0,1,1.9,5.633c-4.711,3.609-14.24,6.077-25.227,6.077s-20.517-2.468-25.228-6.077a3.138,3.138,0,0,1,1.9-5.633",
    transform: "translate(-283.185 -183.26)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M257.2,190.943h58.234a3.388,3.388,0,0,1,3.388,3.388v23.661a3.389,3.389,0,0,1-1.043,2.445l-10.533,10.1a3.388,3.388,0,0,0-1.043,2.445l-.006,68.4a4.092,4.092,0,0,1-4.092,4.091H264.38a3.916,3.916,0,0,1-3.916-3.973l.926-63.592a26.008,26.008,0,0,0-2.772-12.065l-3.914-7.779a8.376,8.376,0,0,1-.894-3.765V194.331a3.388,3.388,0,0,1,3.388-3.388",
    transform: "translate(594.205 343.26)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "av",
    transform: "translate(848.016 537.123)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M292.556,195.027v19.165a4.471,4.471,0,0,0,4.5,4.471l21.768-.125v.151a3.389,3.389,0,0,1-1.043,2.445l-10.533,10.1a3.371,3.371,0,0,0-.807,1.23H260.745a26.016,26.016,0,0,0-2.126-5.923l-3.914-7.78a8.376,8.376,0,0,1-.894-3.765V195.027c0-1.293,37.68.571,38.745,0",
    transform: "translate(-253.811 -194.559)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M289.722,190.943h58.234a3.388,3.388,0,0,1,3.388,3.388v23.661a3.389,3.389,0,0,1-1.043,2.445l-10.533,10.1a3.388,3.388,0,0,0-1.043,2.445l-.006,68.4a4.092,4.092,0,0,1-4.092,4.091H296.9a3.916,3.916,0,0,1-3.916-3.973l.926-63.592a26,26,0,0,0-2.772-12.065l-3.914-7.779a8.376,8.376,0,0,1-.894-3.765V194.331a3.388,3.388,0,0,1,3.388-3.388",
    transform: "translate(535.417 343.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M107.979,158.5a4.726,4.726,0,0,1,5.956-3.032L173.1,174.712a4.726,4.726,0,1,1-2.924,8.988l-59.161-19.246a4.726,4.726,0,0,1-3.032-5.956",
    transform: "translate(854.625 350.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M44.179,178h86.3a8.847,8.847,0,1,1,0,17.693h-86.3a8.847,8.847,0,0,1,0-17.693",
    transform: "translate(950.138 345.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M41.526,178h91.612a6.191,6.191,0,0,1,0,12.383H41.526a6.191,6.191,0,1,1,0-12.383",
    transform: "translate(950.136 345.75)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bh",
    transform: "translate(839.598 529)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M286.744,184.5h44.3a2.507,2.507,0,0,1,2.345,3.237,1.278,1.278,0,0,1-.765.805.878.878,0,0,1-.922-.057c-.612-.519.16-1.169.071-1.765a.723.723,0,0,0-.729-.606h-44.3a.584.584,0,0,1-.584-.584v-.447a.584.584,0,0,1,.584-.584",
    transform: "translate(-286.16 -184.5)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M159.085,0H270.139a18.03,18.03,0,0,1,18.142,16.66,17.7,17.7,0,0,1-10.936,17.5l-4.963,2.052c-3.022,1.249-4.891,2.027-8.565,3.23-1.767.578-4.826.019-5.788-1.724-.942-1.708-1.013-4.262,4.359-6.986l11.563-4.781a8.843,8.843,0,0,0,5.475-8.493,9.052,9.052,0,0,0-9.143-8.569h-111.2a8.868,8.868,0,0,0-8.868,8.867V157.479h-8.883V17.751A17.751,17.751,0,0,1,159.085,0",
    transform: "translate(715.546 380)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M259.815,192.9h14.915a1.354,1.354,0,0,1,0,2.709H259.815a1.354,1.354,0,0,1,0-2.709",
    transform: "translate(633.185 342.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M332.522,142.577a6.875,6.875,0,0,1,7.795,5.587,1.01,1.01,0,0,1-.984,1.2h-.4a1.054,1.054,0,0,1-1.022-.874,4.452,4.452,0,0,0-5.286-3.473,4.557,4.557,0,0,0-3.511,4.521v33.744h-2.423v-33.7a7,7,0,0,1,5.828-7",
    transform: "translate(513.833 352.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M211.293,216.512c-1.3-.938-2.271-1.762-2.271-1.762s1.005.757,2.271,1.762",
    transform: "translate(737.904 338.679)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M214.176,211.492c1.781.488,10.029,6.574,8.61,6.731-1.319.145-3.726-1.367-5.517-2.663C216,214.553,215,213.8,215,213.8s.975.825,2.27,1.763c2.535,2.014,6.119,5.032,4.8,5-2.12-.05-8.636-5.754-8.636-5.754s7.3,6.437,6.415,6.714c-1.615.5-8.581-5.546-8.581-5.546s5.494,7.222,4.391,6.959c-1.478-.354-5.6-5.249-5.6-5.249s-5.187-.388-8.064-2l.8-5.892s9.612,1.21,11.393,1.7",
    transform: "translate(731.929 339.633)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 326.362,
    height: 297.119,
    transform: "translate(791.638 380)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 326.362,
    height: 297.119,
    transform: "translate(791.638 380)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(821.751 665.009)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.054,0A6.055,6.055,0,1,1,0,6.056v0A6.053,6.053,0,0,1,6.054,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientCaricature);
export default __webpack_public_path__ + "static/media/patientCaricature.0afefcbe69165d8ce97df56526628ab0.svg";
export { ForwardRef as ReactComponent };